import { combineReducers } from 'redux';

import club from './club/reducer';
import registration from './registration/reducer';
import personconsent from './personconsent/reducer';

const rootReducer = combineReducers({
    club,
    registration,
    personconsent
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers.jsx